import styled from 'styled-components';

import { MagistralDrug } from '@dreryk/drerykweb-medicine-api';

import { useTranslate } from '@dreryk/react-common';
import {
   appendTestableElementAttributes,
   basicSmallTextStyle,
   Text,
   TextSeparator,
   TextSeparatorType,
} from '@dreryk/react-components';

import { prescriptionsTranslationKeys } from '../../../translations';

const StyledMagistralDrugSubheading = styled.span`
   ${basicSmallTextStyle};
`;

StyledMagistralDrugSubheading.displayName = 'StyledMagistralDrugSubheading';

type MagistralDrugSubheadingProps = Pick<
   MagistralDrug,
   'form' | 'additionalDetails' | 'magistralDrugMedicineRawMaterials'
> & {
   readonly name: string;
};

export const MagistralDrugSubheading = (props: MagistralDrugSubheadingProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledMagistralDrugSubheading>
         <TextSeparator as={'div'} separator={TextSeparatorType.COMMA_SPACE}>
            {props.magistralDrugMedicineRawMaterials.map((material, index) => {
               return (
                  <span key={material.id} {...appendTestableElementAttributes(`material-${index}`)}>
                     <TextSeparator separator={TextSeparatorType.SPACE}>
                        <Text testId={'materialName'}>{material.name}</Text>
                        {material.quantityAbbreviation ? (
                           <Text testId={'materialQuantityAbbreviation'}>
                              {translate(
                                 prescriptionsTranslationKeys.quantityAbbreviation[material.quantityAbbreviation]
                              )}
                           </Text>
                        ) : null}
                        {material.quantity ? <Text testId={'materialQuantity'}>{material.quantity}</Text> : null}
                        {material.quantityUnit ? (
                           <Text testId={'materialQuantityUnit'}>
                              {translate(prescriptionsTranslationKeys.quantityUnitShortcut[material.quantityUnit])}
                           </Text>
                        ) : null}
                     </TextSeparator>
                  </span>
               );
            })}
         </TextSeparator>

         {props.form && props.additionalDetails ? (
            <TextSeparator as={'div'} separator={TextSeparatorType.COMMA_SPACE}>
               <Text testId={'form'}>{props.form}</Text>
               <Text testId={'additionalDetails'}>{props.additionalDetails}</Text>
            </TextSeparator>
         ) : (
            <Text testId={'form'}>{props.form}</Text>
         )}
      </StyledMagistralDrugSubheading>
   );
};
